import { baseService } from './baseService'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../utils/showToast'
class UpdateUserBorrowReturnStatus extends baseService {
  async UpdateStatus(uuidBook, uuidUser) {
    const status = 'REVOKED'
    const payload = {
      userId: uuidUser,
      bookId: uuidBook,
      newStatus: status,
    }
    try {
      showLoadingToast(
        'Đang thu hồi',
        toastKey.BOOKS_MANAGEMENT.BORROW.AccountPerBook.GET
      )
      const res = await this.put('borrow/update-status', payload)
      if (res.status !== 200) throw new Error('Lỗi không lấy được dữ liệu')
      if (!res?.data) throw new Error('Không có dữ liệu!')
      showSuccessToast(
        'Thu hồi thành công',
        toastKey.BOOKS_MANAGEMENT.BORROW.AccountPerBook.GET
      )
    } catch (error) {
      showErrorToast({
        error: error,
        message: error.message,
        toastId: toastKey.BOOKS_MANAGEMENT.BORROW.AccountPerBook.GET,
      })
      throw error
    }
  }
}
export const updateUserBorrowReturnStatus = new UpdateUserBorrowReturnStatus()
